// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:991px){.bell-button[data-v-7a3b31d0]{border:none}}@media only screen and (min-width:992px){.bell-badge[data-v-7a3b31d0] .el-badge__content.is-dot{height:10px;width:10px}.bell-badge[data-v-7a3b31d0] .el-badge__content.is-fixed{transform:translateY(-100%) translateX(175%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
